// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"da3fa28d","367":"3a9bd662","453":"1732ad04","455":"9b912fde","458":"8affb3a9","977":"a4bdf5f4"}[chunkId] + ".chunk.js";
};